import React from 'react';
import Navbar from '../../components/Layouts/Navbar';
import Footer from '../../components/Layouts/Footer';
import PowerBiHeader from '../../components/BusinessAnalytics/PowerBi/PowerBiHeader';
import SubscribeStyleOne from '../../components/Common/SubscribeStyleOne';
import PageSeo from '../../components/Common/PageSeo';
import PowerBiFAQ from '../../components/BusinessAnalytics/PowerBi/PowerBiFAQ';
import PowerBiWeitereServices from '../../components/BusinessAnalytics/PowerBi/PowerBiWeitereServices';
import PowerBiText from '../../components/BusinessAnalytics/PowerBi/PowerBiText';
import PowerBiVerständnisundErfahrungfürIhreBranche from '../../components/BusinessAnalytics/PowerBi/PowerBiVerständnisundErfahrungfürIhreBranche';
import PowerBiCTA from '../../components/BusinessAnalytics/PowerBi/PowerBiCTA';
import PowerBIProjekte from '../../components/BusinessAnalytics/PowerBi/PowerBIProjekte';
import { useTranslations } from '../../locales/useTranslations';
import { useRouter } from 'next/router';

const PowerBi = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('powerBi_seo_title')}
                description={t('powerBi_seo_description')}
                canonical={`${baseUrl}/business-analytics/power-bi/`}
                openGraph={{
                    url: `${baseUrl}/business-analytics/power-bi/`,
                    title: t('powerBi_seo_title'),
                    description: t('powerBi_seo_description'),
                    images: [
                        {
                            url: `${baseUrl}/images/logoog.png`,
                            width: 1200,
                            height: 630,
                            alt: t('powerBi_seo_title'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('powerBi_seo_title'),
                    type: 'website'
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('powerBi_seo_keywords')
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data'
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH'
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel'
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString()
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: `https://simplify-data.de/business-analytics/power-bi/`
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: `https://simplify-data.com/business-analytics/power-bi/`
                    }
                ]}
            />


            <Navbar />
            <PowerBiHeader />
            <PowerBiVerständnisundErfahrungfürIhreBranche />

            <PowerBiText />
            <PowerBIProjekte />
            <PowerBiCTA />
            <PowerBiFAQ />
            <PowerBiWeitereServices />
            <SubscribeStyleOne />
            <Footer />
        </>
    );
}

export default PowerBi;